import { Component } from '@angular/core';

@Component({
    selector: 'Easy-Access',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class EasyAccessComponent {}
